import React from 'react'; 
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Grid, Container, Segment } from 'semantic-ui-react';

const LinksListing = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}  className='tramList__readMore button ui inverted primary'>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href} className='tramList__readMore button ui inverted primary'>{linkTitle || href}</a>;
  }

  return (
    <div className="full-width bg-gray-bg">
      <Container>
        <Segment basic>
          <Grid>
            <Grid.Row colummns={12} as="ul" className="tramList__list list-unstyled my-0">

              {items.map((item) => (
                <Grid.Column as="li" key={item['@id']} className='tramList__item'  mobile={12} tablet={6} computer={4}>
                  <article className="tramItem position-relative">
                      <h3 className='tramItem__title'>
                        <ConditionalLink className="tramItem__link stretched-link" item={item} condition={!isEditMode}>{item.title || item.id}</ConditionalLink>
                      </h3>
                      {item?.description &&
                        <p className='tramItem__description'>{item.description}</p>
                      } 
                      <span className="tramItem__readMore ">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                  </article>
                </Grid.Column>
              ))}

            </Grid.Row> 
          </Grid>
        </Segment>
      </Container>
    </div>
  );
};

LinksListing.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default LinksListing;
